import { render } from "./PassTransparencyForm.vue?vue&type=template&id=619b2b06"
import script from "./PassTransparencyForm.vue?vue&type=script&lang=js"
export * from "./PassTransparencyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__